/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EntityName
 */
export interface EntityName {
}

/**
 * Check if a given object implements the EntityName interface.
 */
export function instanceOfEntityName(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function EntityNameFromJSON(json: any): EntityName {
    return EntityNameFromJSONTyped(json, false);
}

export function EntityNameFromJSONTyped(json: any, ignoreDiscriminator: boolean): EntityName {
    return json;
}

export function EntityNameToJSON(value?: EntityName | null): any {
    return value;
}

